import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import CoverUploader from '@/components/CoverUploader';
import { updateTemplateCoverInfo } from '@/api/creative/custom.js';

export default {
  components: {
    CoverUploader: CoverUploader
  },
  props: {
    config: [Object],
    templateInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      uploadForm: {
        cover_p: '',
        cover_l: ''
      },
      rules: {
        cover_p: [{ required: true, message: '封面图不能为空', trigger: 'change' }],
        cover_l: [{ required: true, message: '封面图不能为空', trigger: 'change' }]
      }
    };
  },

  computed: {
    portraitUrl: function portraitUrl() {
      if (this.templateInfo.thumbnail) return this.templateInfo.thumbnail;
      return '';
    },
    landscapeUrl: function landscapeUrl() {
      if (this.templateInfo.thumbnail_l) return this.templateInfo.thumbnail_l;
      return '';
    }
  },
  watch: {
    'config.visible': function configVisible(val) {
      if (val) {
        this.initForm();
      } else {
        this.$refs.form.clearValidate();
      }
    },
    uploadForm: function uploadForm() {
      this.$refs.form.clearValidate();
    }
  },
  methods: {
    uploadCoverP: function uploadCoverP(res, file) {
      this.uploadForm.cover_p = res.data.url;
    },
    handleCoverPError: function handleCoverPError() {},
    uploadCoverL: function uploadCoverL(res, file) {
      this.uploadForm.cover_l = res.data.url;
    },
    handleCoverLError: function handleCoverLError() {},
    handleSubmit: function handleSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var valid, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$refs.form.validate();

              case 2:
                valid = _context.sent;

                if (!valid) {
                  _context.next = 14;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return updateTemplateCoverInfo({
                  id: _this.templateInfo.src_template_id,
                  thumbnail: _this.uploadForm.cover_p,
                  thumbnail_l: _this.uploadForm.cover_l
                });

              case 7:
                res = _context.sent;

                if (_.get(res, 'data.code') === 0) {
                  // eslint-disable-next-line vue/no-mutating-props
                  _this.config.visible = false;
                  _this.$emit('update');
                  _this.$message({
                    type: 'success',
                    message: '更新成功！'
                  });
                }
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](4);

                console.log(_context.t0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 11]]);
      }))();
    },
    initForm: function initForm() {
      this.uploadForm.cover_p = this.portraitUrl;
      this.uploadForm.cover_l = this.landscapeUrl;
    }
  }
};